<template>
  <div>
    <pre v-if="error">{{ error }}</pre>
    <b-spinner v-else />
  </div>
</template>

<script>
import axios from 'axios';

import {
  STORE_ACCESS_TOKEN,
  PURGE_AUTH,
  FETCH_USER_INFO,
} from '@gid/vue-common/store/auth.module/types';

export default {
  props: {
    token: String,
  },
  data() {
    return {
      error: null,
    };
  },
  async created() {
    if (this.token) {
      try {
        // Clear any existing auth state first to prevent a stale token's
        // FETCH_USER_INFO from racing and triggering a 401 → PURGE_AUTH
        // that wipes the new user data before the router push.
        this.$store.commit(PURGE_AUTH);

        const response = await axios.get(`/api/partner/invite/${this.token}`);
        const { access_token, order_id } = response.data;
        this.$store.commit(STORE_ACCESS_TOKEN, {
          access_token: access_token,
        });
        await this.$store.dispatch(FETCH_USER_INFO);
        this.$router.push({
          name: 'order-single',
          params: { job_id: order_id },
        });
      } catch (error) {
        this.error = error;
      }
    }
  },
};
</script>
